import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Summary() {
  return (
    <section id="business" style={{paddingTop:'35px', paddingBottom:'35px'}}>
      <Container>
        <div className="section-label">Business Summary</div>

        <h2 className="section-title">
          Strategy & Operations
        </h2>

        <div className="divider-gold"></div>

        {/* <div className="kpi-row fade-up">
          <div className="kpi-box">
            <div className="kpi-val">$1.4B+</div>
            <div className="kpi-desc">Assets Under Management</div>
          </div>

          <div className="kpi-box">
            <div className="kpi-val">47</div>
            <div className="kpi-desc">Portfolio Properties</div>
          </div>

          <div className="kpi-box">
            <div className="kpi-val">15 Yrs</div>
            <div className="kpi-desc">Operating Track Record</div>
          </div>

          <div className="kpi-box">
            <div className="kpi-val">2,300+</div>
            <div className="kpi-desc">Investors Served</div>
          </div>
        </div> */}

        <Row className="g-4 mt-3">

          {/* Investment Strategy */}
          <Col lg={12}>
            <div className="business-card fade-up">

              <h5
                style={{
                  fontSize: ".72rem",
                  letterSpacing: ".14em",
                  textTransform: "uppercase",
                  color: "var(--gold)",
                  marginBottom: "20px",
                  fontFamily: "'Founders Grotesk', sans-serif",
                  fontWeight: 700
                }}
              >
                Revenue Growth Strategy
              </h5>

              <p
                style={{
                  fontSize: ".88rem",
                  color: "white",
                  lineHeight: 1.8
                }}
              >
              Nexora's revenue growth strategy is designed around four primary stages.
<p></p>
Stage 1 — Acquire

Target growing businesses with operational processes that are highly repetitive, manual, or fragmented.

Initial customer acquisition will focus on direct sales, strategic partnerships, industry-specific marketing, referrals, and targeted digital campaigns.
<p></p>
Stage 2 — Activate

Convert initial customers through a limited number of high-value workflows.

The objective is to demonstrate measurable value quickly through reduced manual work, improved response times, fewer errors, or increased employee productivity.
<p></p>
Stage 3 — Expand

Once the platform is embedded within an organization, introduce additional workflows, AI agents, users, integrations, and departments.

This expansion strategy is expected to increase average revenue per customer while improving customer retention.
<p></p>
Stage 4 — Enterprise

Develop larger enterprise accounts through advanced security, administrative controls, analytics, integrations, dedicated support, and customized AI functionality.

This stage is intended to increase contract sizes and establish longer-term enterprise relationships.
              </p>

              {/* <p
                style={{
                  fontSize: ".88rem",
                  color: "white",
                  lineHeight: 1.8,
                  marginTop: "16px"
                }}
              >
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
              </p> */}

            </div>
          </Col>


          {/* Use of Proceeds */}
          <Col lg={6}>
            <div className="business-card fade-up">

              <h5
                style={{
                  fontSize: ".72rem",
                  letterSpacing: ".14em",
                  textTransform: "uppercase",
                  color: "var(--gold)",
                  marginBottom: "20px",
                  fontFamily: "'Founders Grotesk', sans-serif",
                  fontWeight: 700
                }}
              >
                Use of Proceeds
              </h5>


              <div style={{ marginTop: "8px" }}>

                {[
                  ["Product & AI Devleopment", "40%"],
                  [
                    "Sales & Marketing ",
                    "25%"
                  ],
                  [
                    "Personnel & Operations",
                    "15%"
                  ],
                  [
                    "Enterprise Infrastructure & Security",
                    "10%",
                  ],
                      [
                    "Working Capital & General Corporate Purposes",
                    "10%"
                  ]
                  
                ].map(([label, percent], index) => (

                  <div key={index}>

                    <div className="d-flex justify-content-between align-items-center mb-2">

                      <span
                        style={{
                          fontSize: ".82rem",
                          color: "var(--white)"
                        }}
                      >
                        {label}
                      </span>

                      <span
                        style={{
                          fontSize: ".9rem",
                          color: "var(--white)"
                        }}
                      >
                        {percent}
                      </span>

                    </div>


                    <div
                      className="progress mb-3"
                      style={{
                        height: "2px"
                      }}
                    >

                      <div
                        className="progress-bar"
                        style={{
                          width: percent,
                          background: "var(--gold)"
                        }}
                      />

                    </div>

                  </div>

                ))}

              </div>

            </div>
          </Col>


          {/* Development Milestones */}
          <Col lg={6}>
            <div className="business-card fade-up">

              <h5
                style={{
                  fontSize: ".72rem",
                  letterSpacing: ".14em",
                  textTransform: "uppercase",
                  color: "var(--gold)",
                  marginBottom: "20px",
                  fontFamily: "'Founders Grotesk', sans-serif",
                  fontWeight: 700
                }}
              >
                Development Milestones
              </h5>


              <div className="timeline">

                <div className="tl-item">
                  <div className="tl-year">Months 1-6</div>
                  <div className="tl-text">
                    Build the Foundation
                  </div>
                </div>


                <div className="tl-item">
                  <div className="tl-year">Months 7-12</div>
                  <div className="tl-text">
                   Accelerate Customer Acquisition
                  </div>
                </div>


                <div className="tl-item">
                  <div className="tl-year">Months 13-24</div>
                  <div className="tl-text">
                    Expand the Platform
                  </div>
                </div>


                <div className="tl-item">
                  <div className="tl-year">Months 25-36</div>
                  <div className="tl-text">
                  Scale the Enterprise Business
                  </div>
                </div>

              </div>

            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
}

export default Summary;